import { useQuery } from '@tanstack/react-query';
import { Link } from 'wouter';
import { api } from '@/api/api-client';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/auth-context';
export function ClientMaintenanceWarning() {
  const { user } = useAuth();
  const query = useQuery({
    queryKey: ['client-data-state'],
    queryFn: async () =>
      (
        await api.get<{ active: boolean; needsRefresh: boolean; message: string }>(
          '/client-data-state',
        )
      ).data,
    staleTime: 5_000,
    refetchInterval: (query) => (query.state.data?.active ? 5_000 : 30_000),
    refetchOnWindowFocus: true,
    retry: false,
  });
  if (!query.data?.active && !query.data?.needsRefresh) return null;
  return (
    <div
      role="status"
      className="border-b border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950 dark:bg-amber-950 dark:text-amber-100"
    >
      <div className="mx-auto flex max-w-[1600px] flex-wrap items-center gap-3">
        <strong>
          {query.data.active ? 'Restaurante em manutenção' : 'Dados operacionais atualizados'}
        </strong>
        <span>{query.data.message}</span>
        {query.data.needsRefresh ? (
          <Button size="sm" variant="outline" onClick={() => window.location.reload()}>
            Recarregar sessão
          </Button>
        ) : null}
        {user?.role === 'OWNER' ? (
          <Link href="/portal-financeiro" className="font-semibold underline">
            Portal Financeiro
          </Link>
        ) : null}
      </div>
    </div>
  );
}
